module.exports = __webpack_public_path__ + "static/2nd-tpm-1-159d253ce9074074f268ab892e14aa28.jpg";